const Signature = ({ parent }) => {
    const { $t } = parent;

    const signatureHTML =
        '<a target="_blank" href="https://searchbooster.io/">SearchBooster.io</a>';

    return (
        <div
            class="l-ss-c-sb-label"
            domPropsInnerHTML={`${$t('signature', [signatureHTML])}`}>
        </div>
    );
};

export default Signature;
